export const setCaptureBtn = function($) {
  $.Viewer.prototype.capture = function(options) {
    if (!this.captureInstance) {
        options = options || {};
        options.viewer = this;
        this.captureInstance = new $.Capture(options);
    } else {
        this.captureInstance.refresh(options);
    }
  };

  $.Capture = function( options = {} ) {
    this.viewer = options.viewer;

    this.divElem = document.createElement('button');
    this.textNode = document.createTextNode('Capture');
    this.divElem.appendChild(this.textNode);
    this.viewer.container.appendChild(this.divElem);

    this.divElem.style.position = 'absolute';
    this.divElem.style.cursor = 'pointer';
    this.divElem.style.margin = '0';
    this.divElem.style.height = '1.45rem';
    this.divElem.style.padding = '0 0.4rem';
    this.divElem.style.fontSize = '0.6rem';
    this.divElem.style.top = '5px';
    this.divElem.style.right = '25.5em';
    this.divElem.style.border = '1px solid rgba(255, 255, 255, 0.3)';
    this.divElem.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.15)';
    this.divElem.style.borderRadius = '4px';
    this.divElem.style.color = 'white';
    this.divElem.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';

    this.divElem.addEventListener('mouseover', () => {
      this.divElem.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
      this.divElem.style.borderColor = 'rgba(255, 255, 255, 0.5)';
    });

    this.divElem.addEventListener('mouseout', () => {
      this.divElem.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
      this.divElem.style.borderColor = 'rgba(255, 255, 255, 0.3)';
    });

    this.divElem.addEventListener('click', () => {
      try {
        const imgCanvas = this.viewer.drawer.canvas;
        const captureCanvas = document.createElement('canvas');
        captureCanvas.width = imgCanvas.width;
        captureCanvas.height = imgCanvas.height;
        const ctx = captureCanvas.getContext('2d');
        ctx.drawImage(imgCanvas, 0, 0);
        const scalebar = this.viewer.scalebarInstance;
        if (scalebar) {
          const container = this.viewer.container;
          const scaleX = imgCanvas.width / container.offsetWidth;
          const scaleY = imgCanvas.height / container.offsetHeight;

          if (scalebar.divElt && scalebar.divElt.style.display !== 'none') {
            const scaleCanvas = scalebar.getAsCanvas();
            const location = scalebar.getScalebarLocation();
            ctx.drawImage(
              scaleCanvas,
              location.x * scaleX,
              location.y * scaleY,
              scaleCanvas.width * scaleX,
              scaleCanvas.height * scaleY,
            );
          }
        }

        captureCanvas.toBlob((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'capture.png';
            link.click();
            setTimeout(() => URL.revokeObjectURL(url), 100);
          }
        }, 'image/png');
      } catch (error) {
        console.error('Capture failed:', error);
      }
    });
  };

  $.Capture.prototype.refresh = function(options) {
    const { visible = true } = options || {};
    this.setVisible(visible);
  };

  $.Capture.prototype.setVisible = function(visible) {
    this.divElem.style.display = visible ? 'block' : 'none';
  };

  $.Capture.prototype.destroy = function() {
    if (this.divElem && this.divElem.parentNode) {
      this.divElem.parentNode.removeChild(this.divElem);
    }
  };
};